export const disabledColor = 'lightgray';
export const disabledLineColor = 'gray';
